import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import type { NotifFilter } from "../lib/notif";

import { notifKeys } from "./query-keys";

export function useListNotifications(filter?: NotifFilter, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: notifKeys.list(filter),
    queryFn: async () => {
      const query: NotifFilter = {};

      if (filter?.severity !== undefined) query.severity = filter.severity;
      if (filter?.type !== undefined) query.type = filter.type;
      if (filter?.read !== undefined) query.read = filter.read;
      if (filter?.offset !== undefined) query.offset = filter.offset;
      if (filter?.limit !== undefined) query.limit = filter.limit;

      const { data, error } = await apiClient.GET("/v1/notifications", {
        params: { query },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
    enabled: options?.enabled ?? true,
  });
}
